import React, { Component } from 'react';
import {
  Button,
  Form,
  Grid,
  Icon,
  Label,
  Radio,
  Responsive,
  Tab,
} from 'semantic-ui-react';
import { reduxForm, Field, change, arrayPush } from 'redux-form';
import PropTypes from 'prop-types';
import _ from 'lodash';

import { TitledCard } from 'Components/';
import {
  IngredientFieldEnum as IngFields,
  RecipeFieldEnum as Fields,
  PreparationInstructionEnum as PreparationInstructionFields,
} from 'Common/FieldEnum';
import {
  makeOptionsData,
  makeOptionsWithNull,
  scrollOnSubmitFail,
} from 'Common/FormHelper';
import {
  InputField,
  SelectField,
  TextAreaField,
  Checkbox,
  IntegerFractionalField,
} from 'Common/SemanticWrapper';
import { EDIT_RECIPE_FORM_NAME, InputMode } from 'Common/FormEnum';
import { withRecipesSubscription } from 'Common/Components/RecipeSearch';
import ImageUploader from 'Common/Components/ImageUploader/ImageUploader';
import { IngredientTableModal } from 'Pages/managerecipe/components/IngredientTableModal';
import { RecipeIngredientTable } from 'Pages/managerecipe/components/RecipeIngredientTable';
import { PreparationInstructions } from 'Pages/managerecipe/components/PreparationInstructions/PreparationInstructions';
import { withIngredientApi } from 'Pages/managerecipe/components/IngredientTable';
import MPWWebApi from 'API/MPWApi';
import { NutritionalFacts } from 'Common/Components/NutritionalFacts/NutritionalFacts';
import { COMPONENT_TYPE } from 'Common/Components/NutritionalHover/constants/constants';
import { hasWholeValue } from 'Common/Components/NutritionalHover/helpers/helpers';
import { createToast, toastType } from 'Common/ToastHelper';
import { MealComponent } from 'Common/Components/MealComponent/MealComponent';
import Allergens from 'Common/Components/Allergens/Allergens';
import Attributes from 'Common/Components/Attributes/Attributes';
import { setNotificationDialog } from 'Components/dialogs/state/actions';
import { NOTIFICATION_DIALOG_MESSAGES } from 'Common/Constants';
import { UserModified } from 'Common/Components/UserModified/UserModified';

import { addVegetables } from '../../helpers/recipe';
import {
  LEFTOVER_RULES,
  ADD_INGREDIENT_HEADER,
  SELECT_FAT_HEADER,
} from 'Pages/managerecipe/helpers/constants';

const IngredientTableModalWithApi = withIngredientApi(IngredientTableModal, {
  useSecondaryPaging: true,
});

const ING_INITIAL_SEARCH_PARAMETERS = Object.freeze({
  Page: 1,
  PageSize: 10,
  Search: '',
  ShowInvLinked: false,
  ShowInactive: false,
});

class EditRecipeFormContainer extends Component {
  static propTypes = {
    recipeId: PropTypes.string,
    onRecipeImageDrop: PropTypes.func.isRequired,
    onRecipeImageRemove: PropTypes.func.isRequired,
    recipeImage: PropTypes.string,
    formValues: PropTypes.object.isRequired,
    handleToggleActive: PropTypes.func.isRequired,
    isReadOnly: PropTypes.bool,
  };

  static defaultProps = {
    recipeId: '',
    recipeImage: '',
    isReadOnly: false,
  };

  MODAL_TYPES = {
    ADD_INGREDIENT: 0,
    ADD_FAT_TYPE: 1,
  };

  state = {
    showIngredientModal: false,
    ingredientSearchParameters: {
      ...ING_INITIAL_SEARCH_PARAMETERS,
    },
    ingredientTableLoading: false,
    ingredientModalType: this.MODAL_TYPES.ADD_INGREDIENT, // determines whether the onAddIngredient is for selecing a fat type or adding an ingredient to recipe
  };

  onIngredientModalClose = () =>
    this.setState({
      showIngredientModal: false,
    });

  onIngredientModalOpen = (type) => () =>
    this.setState({
      showIngredientModal: true,
      ingredientModalType: type,
      ingredientSearchParameters: {
        ...ING_INITIAL_SEARCH_PARAMETERS,
      },
    });

  onSearchParametersChange = (searchParameters) =>
    this.setState({ ingredientSearchParameters: searchParameters });

  openNewTab = (url) => window.open(url, '_blank');

  onAddIngredient = (ingredient) => {
    const { dispatch } = this.props;
    const { ingredientModalType } = this.state;

    let message = 'Added Ingredient!';

    if (ingredientModalType === this.MODAL_TYPES.ADD_INGREDIENT) {
      ingredient[IngFields.Measure1] = ingredient[IngFields.Measures][0];

      dispatch(
        arrayPush(EDIT_RECIPE_FORM_NAME, Fields.Ingredients, ingredient)
      );
    } else if (ingredientModalType === this.MODAL_TYPES.ADD_FAT_TYPE) {
      dispatch(
        change(EDIT_RECIPE_FORM_NAME, Fields.TypeOfFat, ingredient.CN_Code)
      );
      dispatch(
        change(
          EDIT_RECIPE_FORM_NAME,
          Fields.TypeOfFatDescription,
          ingredient.IngredientName
        )
      );

      message = 'Added Fat!';
      this.onIngredientModalClose();
    }

    createToast(toastType.success, 'Success', message, true);
  };

  removeTypeOfFat = () => {
    const { dispatch } = this.props;
    dispatch(
      setNotificationDialog({
        ...NOTIFICATION_DIALOG_MESSAGES.REMOVE_TYPE_OF_FAT,
        actionsToDispatchOnOk: [
          change(EDIT_RECIPE_FORM_NAME, Fields.TypeOfFat, ''),
          change(EDIT_RECIPE_FORM_NAME, Fields.TypeOfFatDescription, ''),
        ],
      })
    );
  };

  recipeIdComponent = (recipeId) => {
    return <div className={'recipe-id-container'}>{recipeId}</div>;
  };

  handleGetRecipeNutritionFacts = () => {
    const { handleGetRecipeNutritionFacts } = this.props;

    handleGetRecipeNutritionFacts.cancel();
    handleGetRecipeNutritionFacts(false);
  };

  BasicRecipeDetails = () => {
    const {
      recipeCategories,
      recipeHACCP,
      recipeServingTemp,
      recipeSources,
      recipeGroups,
      recipeId,
      isReadOnly,
    } = this.props;

    return (
      <TitledCard
        title={recipeId && this.recipeIdComponent(recipeId)}
        headerClass={'title-card-header'}
      >
        <Grid>
          <Grid.Row>
            <Grid.Column width={16}>
              <Field
                component={InputField}
                label={'Recipe Name'}
                maxLength={60}
                name={Fields.Description}
                fluid
                showOnlyTouchedError
                hideEmptyError
                autoFocus
                disabled={isReadOnly}
              />
            </Grid.Column>
          </Grid.Row>
          <Grid.Row>
            <Grid.Column width={10}>
              <Field
                component={InputField}
                label={'Menu Name'}
                maxLength={40}
                name={Fields.Name}
                fluid
                showOnlyTouchedError
                hideEmptyError
                disabled={isReadOnly}
              />
            </Grid.Column>
            <Grid.Column width={6}>
              <Field
                component={SelectField}
                label={'Meal Category'}
                options={makeOptionsData(recipeCategories)}
                name={Fields.RecipeCategoryId}
                fluid
                disabled={isReadOnly}
              />
            </Grid.Column>
          </Grid.Row>
          <Grid.Row>
            <Grid.Column width={16}>
              <Field
                component={TextAreaField}
                label={'Marketing Description'}
                maxLength={150}
                name={Fields.MarketingDescription}
                disabled={isReadOnly}
              />
            </Grid.Column>
          </Grid.Row>

          <Grid.Row columns="equal">
            <Grid.Column>
              <Field
                component={SelectField}
                label={'HACCP'}
                options={makeOptionsWithNull(recipeHACCP)}
                name={Fields.HACCPId}
                fluid
                disabled={isReadOnly}
              />
            </Grid.Column>
            <Grid.Column>
              <Field
                component={SelectField}
                label={'Serving Temp'}
                options={makeOptionsWithNull(recipeServingTemp)}
                name={Fields.ServingTemperatureId}
                fluid
                disabled={isReadOnly}
              />
            </Grid.Column>
            <Grid.Column>
              <Field
                component={SelectField}
                label={'Source'}
                options={makeOptionsWithNull(recipeSources)}
                name={Fields.RecipeSourceId}
                fluid
                disabled={isReadOnly}
              />
            </Grid.Column>
          </Grid.Row>
          <Grid.Row columns="equal">
            <Grid.Column>
              <Field
                component={SelectField}
                label={'Group'}
                options={makeOptionsWithNull(recipeGroups)}
                name={Fields.GroupId}
                fluid
                disabled={isReadOnly}
              />
            </Grid.Column>
            <Grid.Column>
              <Field
                component={SelectField}
                label={'Share With'}
                options={[]}
                name={Fields.ShareId}
                fluid
                disabled={isReadOnly}
              />
            </Grid.Column>
            <Grid.Column>
              <Field
                component={SelectField}
                label={'Leftover Rule'}
                options={LEFTOVER_RULES}
                name={Fields.LeftoverDays}
                fluid
                disabled={isReadOnly}
              />
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </TitledCard>
    );
  };

  PictureUploader = () => {
    const {
      onRecipeImageDrop,
      onRecipeImageRemove,
      recipeImage,
      formValues,
      handleToggleActive,
      openIngredientModal,
      convertRecipeToIngredient,
      hasSubRecipes,
      isReadOnly,
    } = this.props;

    const ingredientId = formValues[Fields.ConvertedToIngredientId];
    const createdFromIngredientId = formValues[Fields.CreatedFromIngredientId];
    let convertToIngredientText = 'Convert To Ingredient';
    if (ingredientId) {
      convertToIngredientText = `View Ingredient\n\n${
        formValues[Fields.ConvertedToIngredientCNCode]
      } - ${formValues[Fields.ConvertedToIngredientDescription]}`;
    }

    const ingredientButtonClick = ingredientId
      ? () => openIngredientModal(ingredientId)
      : convertRecipeToIngredient;

    return (
      <TitledCard title={``} headerClass={'title-card-header'}>
        <Grid columns={1}>
          <Grid.Row>
            <Grid.Column width={16}>
              <ImageUploader
                displayImage={recipeImage}
                onDrop={onRecipeImageDrop}
                onImageRemove={onRecipeImageRemove}
                alt="Upload Recipe Image"
                disabled={isReadOnly}
              />
            </Grid.Column>
          </Grid.Row>
          <Grid.Row>
            <Grid.Column width={16} className={'recipe-active-container'}>
              <Radio
                toggle
                checked={formValues[Fields.Inactive] === 'Y'}
                onChange={handleToggleActive}
                disabled={isReadOnly}
              />
              <div className={'active-label'}>Inactive</div>
            </Grid.Column>
          </Grid.Row>
          {!hasSubRecipes && !createdFromIngredientId && (
            <Grid.Row>
              <Grid.Column width={16} textAlign="center">
                <Button
                  onClick={ingredientButtonClick}
                  style={{ marginTop: 14 }}
                  disabled={isReadOnly}
                >
                  {convertToIngredientText}
                </Button>
              </Grid.Column>
            </Grid.Row>
          )}
        </Grid>
      </TitledCard>
    );
  };

  NutritionFacts = () => {
    const {
      formValues,
      initialFormValues,
      userModifiedAllergens,
      userModifiedAttributes,
      userModifiedMealComponents,
      isReadOnly,
    } = this.props;

    const totalVeg = addVegetables(formValues);

    const data = {
      ...formValues,
      [Fields.TotalVeg]: totalVeg,
    };

    return (
      <Grid padded>
        <Grid.Column
          mobile={8}
          tablet={8}
          computer={8}
          largeScreen={8}
          widescreen={4}
        >
          <TitledCard title="Nutrition Fact Label">
            <div className="nutrition-facts-container">
              <NutritionalFacts
                data={{
                  ...data,
                  ...initialFormValues,
                  [Fields.TotalVeg]: totalVeg,
                }}
                formName={EDIT_RECIPE_FORM_NAME}
                hideBaseWeightField={true}
              />
            </div>
          </TitledCard>
        </Grid.Column>
        <Grid.Column
          mobile={8}
          tablet={8}
          computer={8}
          largeScreen={8}
          widescreen={4}
        >
          <TitledCard
            title="Meal Component"
            rightItem={
              userModifiedMealComponents && (
                <UserModified
                  user={userModifiedMealComponents.User}
                  modifiedDT={userModifiedMealComponents.ModifiedDT}
                />
              )
            }
          >
            <div className="meal-component-container">
              <MealComponent
                formName={EDIT_RECIPE_FORM_NAME}
                isReadOnly={isReadOnly}
                data={data}
              />
            </div>
          </TitledCard>
        </Grid.Column>
        <Grid.Column
          mobile={8}
          tablet={8}
          computer={8}
          largeScreen={8}
          widescreen={4}
        >
          <TitledCard
            title="Allergens"
            rightItem={
              userModifiedAllergens && (
                <UserModified
                  user={userModifiedAllergens.User}
                  modifiedDT={userModifiedAllergens.ModifiedDT}
                />
              )
            }
          >
            <Allergens
              formName={EDIT_RECIPE_FORM_NAME}
              isReadOnly={isReadOnly}
              {...this.props}
              formValues={data}
            />
          </TitledCard>
        </Grid.Column>
        <Grid.Column
          mobile={8}
          tablet={8}
          computer={8}
          largeScreen={8}
          widescreen={4}
        >
          <TitledCard
            title="Attributes"
            rightItem={
              userModifiedAttributes && (
                <UserModified
                  user={userModifiedAttributes.User}
                  modifiedDT={userModifiedAttributes.ModifiedDT}
                />
              )
            }
          >
            <Attributes
              formName={EDIT_RECIPE_FORM_NAME}
              isReadOnly={isReadOnly}
              {...this.props}
            />
          </TitledCard>
        </Grid.Column>
      </Grid>
    );
  };

  MoistureFatChange = () => {
    const { formValues, isReadOnly } = this.props;

    return (
      <Grid padded>
        <Grid.Row columns="1">
          <Grid.Column>
            <Field
              component={TextAreaField}
              label="Cooking Method"
              maxLength={150}
              name={Fields.CookingMethod}
              disabled={isReadOnly}
            />
          </Grid.Column>
        </Grid.Row>
        <Grid.Row>
          <Grid.Column width="3">
            <Field
              component={InputField}
              fluid
              label="Moisture Change"
              name={Fields.MoistureChange}
              labelPosition="right"
              mode={InputMode.Decimal}
              numericSize={[6, 2]}
              allowNegative
              hideEmptyError
              fieldLabel={{ basic: true, content: <Icon name="percent" /> }}
              disabled={isReadOnly}
            />
          </Grid.Column>
        </Grid.Row>

        <Grid.Row>
          <Grid.Column width={3}>
            <Field
              component={InputField}
              label="Fat Change"
              fluid
              name={Fields.FatChange}
              labelPosition="right"
              mode={InputMode.Decimal}
              numericSize={[6, 2]}
              allowNegative
              hideEmptyError
              fieldLabel={{ basic: true, content: <Icon name="percent" /> }}
              disabled={isReadOnly}
            />
          </Grid.Column>
          <Grid.Column width="13" verticalAlign="bottom">
            {formValues[Fields.TypeOfFat] ? (
              <React.Fragment>
                <Label basic pointing="left">
                  {formValues[Fields.TypeOfFat]} -{' '}
                  {formValues[Fields.TypeOfFatDescription]}{' '}
                </Label>
                <Icon
                  color="red"
                  size="large"
                  name="trash"
                  link
                  onClick={this.removeTypeOfFat}
                />
              </React.Fragment>
            ) : (
              <Button
                onClick={this.onIngredientModalOpen(
                  this.MODAL_TYPES.ADD_FAT_TYPE
                )}
                disabled={isReadOnly}
              >
                Select Fat Ingredient
              </Button>
            )}
          </Grid.Column>
        </Grid.Row>
      </Grid>
    );
  };

  tabPanes = [
    {
      menuItem: 'Nutrition Facts',
      render: () => {
        const { NutritionFacts } = this;
        return (
          <Tab.Pane>
            <NutritionFacts />
          </Tab.Pane>
        );
      },
    },
    {
      menuItem: 'Preparation Instructions',
      render: () => {
        const { formValues, isReadOnly } = this.props;
        return (
          <Tab.Pane>
            <PreparationInstructions
              data={formValues}
              isReadOnly={isReadOnly}
            />
          </Tab.Pane>
        );
      },
    },
    {
      menuItem: 'Moisture and Fat Change (%)',
      render: () => {
        const { MoistureFatChange } = this;
        return (
          <Tab.Pane>
            <MoistureFatChange />
          </Tab.Pane>
        );
      },
    },
    {
      menuItem: 'Production Notes',
      render: () => {
        const { isReadOnly } = this.props;
        return (
          <Tab.Pane className="recipe-tab-container">
            <Field
              className="recipe-tab-textarea"
              name={Fields.ProductionNotes}
              component={TextAreaField}
              maxLength={1500}
              disabled={isReadOnly}
            />
          </Tab.Pane>
        );
      },
    },
    {
      menuItem: 'Purchasing Notes',
      render: () => {
        const { isReadOnly } = this.props;
        return (
          <Tab.Pane className="recipe-tab-container">
            <Field
              className="recipe-tab-textarea"
              name={Fields.PurchasingNotes}
              component={TextAreaField}
              maxLength={1500}
              disabled={isReadOnly}
            />
          </Tab.Pane>
        );
      },
    },
    {
      menuItem: 'Serving Notes',
      render: () => {
        const { isReadOnly } = this.props;
        return (
          <Tab.Pane className="recipe-tab-container">
            <Field
              className="recipe-tab-textarea"
              name={Fields.ServingNotes}
              component={TextAreaField}
              maxLength={1500}
              disabled={isReadOnly}
            />
          </Tab.Pane>
        );
      },
    },
    {
      menuItem: 'Miscellaneous Notes',
      render: () => {
        const { isReadOnly } = this.props;
        return (
          <Tab.Pane className="recipe-tab-container">
            <Field
              className="recipe-tab-textarea"
              name={Fields.MiscellaneousNotes}
              component={TextAreaField}
              maxLength={1500}
              disabled={isReadOnly}
            />
          </Tab.Pane>
        );
      },
    },
    {
      menuItem: 'Temperature',
      render: () => {
        const { isReadOnly } = this.props;
        return (
          <Tab.Pane className="recipe-tab-container">
            <Grid>
              <Grid.Row>
                <Grid.Column width={3}>
                  <Field
                    name={Fields.TargetTemp}
                    component={InputField}
                    disabled={isReadOnly}
                    label={'Cook/Prep Target Temp'}
                    maxLength={4}
                  />
                </Grid.Column>
                <Grid.Column width={3}>
                  <Field
                    name={Fields.HoldTemp}
                    component={InputField}
                    disabled={isReadOnly}
                    label={'Hold Target Temp'}
                    maxLength={4}
                  />
                </Grid.Column>
              </Grid.Row>
            </Grid>
          </Tab.Pane>
        );
      },
    },
  ];

  Yield = () => {
    const { isReadOnly } = this.props;
    return (
      <TitledCard title="Yield">
        <Grid>
          <Grid.Row>
            <Grid.Column width={6}>
              <Field
                component={InputField}
                label={'# of Servings'}
                name={Fields.NumberOfPortion}
                mode={InputMode.Decimal}
                numericSize={[8, 2]}
                fluid
                disabled={isReadOnly}
              />
            </Grid.Column>
            <Grid.Column width={10} verticalAlign="middle">
              <Field
                component={Checkbox}
                label={'Lock Batch'}
                name={Fields.LockBatch}
                disabled={isReadOnly}
              />
            </Grid.Column>
          </Grid.Row>
          <Grid.Row columns="equal">
            <Grid.Column>
              <Field
                component={IntegerFractionalField}
                name={Fields.QtyOfPortion}
                label="Serving Size"
                fluid
                disabled={isReadOnly}
              />
            </Grid.Column>

            <Grid.Column>
              <Field
                component={InputField}
                label={'Serving Unit'}
                maxLength={10}
                name={Fields.MeasureOfPortion}
                fluid
                disabled={isReadOnly}
              />
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </TitledCard>
    );
  };

  render() {
    const { BasicRecipeDetails, PictureUploader, Yield } = this;
    const {
      showIngredientModal,
      ingredientSearchParameters,
      ingredientTableLoading,
      ingredientModalType,
    } = this.state;
    const { formValues, openIngredientModal, isReadOnly } = this.props;

    return (
      <React.Fragment>
        <Form>
          <Responsive as={Grid} minWidth={1601}>
            <Grid.Row>
              <Grid.Column width={8}>
                <BasicRecipeDetails />
              </Grid.Column>
              <Grid.Column width={4}>
                <Yield />
              </Grid.Column>
              <Grid.Column width={4}>
                <PictureUploader />
              </Grid.Column>
            </Grid.Row>
          </Responsive>

          <Responsive as={Grid} maxWidth={1600}>
            <Grid.Row>
              <Grid.Column width={16}>
                <BasicRecipeDetails />
              </Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={8}>
                <Yield />
              </Grid.Column>
              <Grid.Column width={8}>
                <PictureUploader />
              </Grid.Column>
            </Grid.Row>
          </Responsive>
          <Grid>
            <Grid.Row>
              <Grid.Column>
                <TitledCard
                  title="Ingredients"
                  rightItem={
                    <div className="ingredient-quick-button-container">
                      <Button
                        onClick={() =>
                          this.openNewTab(
                            'https://foodbuyingguide.fns.usda.gov'
                          )
                        }
                      >
                        Food Buying Guide
                      </Button>
                      <Button
                        onClick={() =>
                          this.openNewTab(
                            'https://foodplanner.healthiergeneration.org/calculator'
                          )
                        }
                      >
                        Smart Snack Calculator
                      </Button>
                      <Button
                        onClick={() =>
                          this.openNewTab(
                            'https://foodplanner.healthiergeneration.org/cacfp-calculator'
                          )
                        }
                      >
                        CACFP Calculator
                      </Button>
                    </div>
                  }
                >
                  <Button
                    onClick={this.onIngredientModalOpen(
                      this.MODAL_TYPES.ADD_INGREDIENT
                    )}
                    disabled={isReadOnly}
                  >
                    Add Ingredient
                  </Button>
                  <div className="recipe-ingredients-container">
                    <RecipeIngredientTable
                      formValues={formValues}
                      loading={ingredientTableLoading}
                      openIngredientModal={openIngredientModal}
                      isReadOnly={isReadOnly}
                    />
                  </div>
                </TitledCard>
              </Grid.Column>
            </Grid.Row>
          </Grid>
          <Grid columns={1} className="tabs-container">
            <Grid.Column>
              <Tab
                menu={{
                  color: 'blue',
                  inverted: true,
                  attached: true,
                }}
                panes={this.tabPanes}
              />
            </Grid.Column>
          </Grid>
        </Form>
        <IngredientTableModalWithApi
          modalProps={{
            size: 'large',
            open: showIngredientModal,
            onClose: this.onIngredientModalClose,
          }}
          headerTitle={
            ingredientModalType === this.MODAL_TYPES.ADD_INGREDIENT
              ? ADD_INGREDIENT_HEADER
              : SELECT_FAT_HEADER
          }
          onAddIngredient={this.onAddIngredient}
          searchParameters={ingredientSearchParameters}
          onSearchParametersChange={this.onSearchParametersChange}
          openIngredientModal={openIngredientModal}
          manual={true}
          hideInactiveToggle={true}
        />
      </React.Fragment>
    );
  }
}

const validate = (values) => {
  const errors = {};

  if (!values[Fields.Description]) {
    errors[Fields.Description] = 'Required';
  }

  if (!values[Fields.Name]) {
    errors[Fields.Name] = 'Required';
  }

  if (!values[Fields.RecipeCategoryId]) {
    errors[Fields.RecipeCategoryId] = 'Required';
  }

  const hasVeg =
    hasWholeValue(values[Fields.OtherVeg]) ||
    hasWholeValue(values[Fields.AdditionalVeg]) ||
    hasWholeValue(values[Fields.LegumesVeg]) ||
    hasWholeValue(values[Fields.StarchyVeg]) ||
    hasWholeValue(values[Fields.DarkGreenVeg]) ||
    hasWholeValue(values[Fields.RedOrangeVeg]);

  const hasFruit = hasWholeValue(values[Fields.Fruit]);

  if (
    hasVeg &&
    hasFruit &&
    values[Fields.ComponentType] === COMPONENT_TYPE.Juice
  ) {
    errors[Fields.Fruit] = 'Recipe cannot have fruit and vegetable juice.';
  }

  if (values[Fields.Ingredients]) {
    values[Fields.Ingredients].forEach((ingredient, i) => {
      if (
        !ingredient[IngFields.Quantity1] ||
        !Number.parseFloat(ingredient[IngFields.Quantity1])
      ) {
        _.set(
          errors,
          `${Fields.Ingredients}[${i}].${IngFields.Quantity1}`,
          'Required'
        );
      }
      if (!ingredient[IngFields.Measure1]) {
        _.set(
          errors,
          `${Fields.Ingredients}[${i}].${IngFields.Measure1}`,
          'Required'
        );
      }
      if (ingredient[IngFields.Quantity2] && !ingredient[IngFields.Measure2]) {
        _.set(
          errors,
          `${Fields.Ingredients}[${i}].${IngFields.Measure2}`,
          'Required'
        );
      } else if (
        ingredient[IngFields.Measure2] &&
        (!ingredient[IngFields.Quantity2] ||
          !Number.parseFloat(ingredient[IngFields.Quantity2]))
      ) {
        _.set(
          errors,
          `${Fields.Ingredients}[${i}].${IngFields.Quantity2}`,
          'Required'
        );
      }
    });
  }

  if (
    !values[Fields.NumberOfPortion] ||
    Number(values[Fields.NumberOfPortion]) < 1
  ) {
    errors[Fields.NumberOfPortion] = 'Number of servings must be 1 or more.';
  }

  if (Number(values[Fields.NumberOfPortion]) > 999999) {
    errors[Fields.NumberOfPortion] =
      'Number of servings must be equal to or less than 999999';
  }

  if (!Number(values[Fields.QtyOfPortion])) {
    errors[Fields.QtyOfPortion] = 'Required';
  } else if (Number(values[Fields.QtyOfPortion] > 99)) {
    errors[Fields.QtyOfPortion] =
      'Serving size must be equal to or less than 99';
  }

  if (!values[Fields.MeasureOfPortion]) {
    errors[Fields.MeasureOfPortion] = 'Required';
  }

  if (values[Fields.PreparationInstructions]) {
    values[Fields.PreparationInstructions].forEach((instruction, i) => {
      if (!instruction[PreparationInstructionFields.Step]) {
        _.set(
          errors,
          `${Fields.PreparationInstructions}[${i}].${PreparationInstructionFields.Step}`,
          'Required'
        );
      }
    });
  }

  return errors;
};

const asyncValidate = (values, dispatch, props, field) => {
  return new Promise(async (resolve, reject) => {
    let errors = {};
    const fieldValue = _.get(values, field, null);
    if (fieldValue && field && field.indexOf(Fields.AllAllergens) !== -1) {
      const localDescription = fieldValue.toLowerCase();
      const response = await MPWWebApi.getGeneric(`Allergen`);
      response.data.Data.forEach((allergen) => {
        if (allergen.Description.toLowerCase() === localDescription) {
          _.setWith(errors, field, 'Allergen name taken', Object);
        }
      });
    }

    if (Object.keys(errors).length) {
      return reject(errors);
    }

    resolve();
  });
};

const getNutritionFactsTriggers = [
  Fields.Ingredients,
  Fields.QtyOfPortion,
  Fields.MeasureOfPortion,
  Fields.MoistureChange,
  Fields.FatChange,
  Fields.NumberOfPortion,
];

const onChange = (values, dispatch, props, previousValues) => {
  if (values && previousValues && Object.keys(previousValues).length) {
    const totalVeg = addVegetables(values);
    dispatch(change(EDIT_RECIPE_FORM_NAME, Fields.TotalVeg, totalVeg));
    const currentValueTriggers = _.pick(values, getNutritionFactsTriggers);
    const prevValueTriggers = _.pick(previousValues, getNutritionFactsTriggers);

    if (!_.isEqual(currentValueTriggers, prevValueTriggers)) {
      props.handleGetRecipeNutritionFacts.cancel();
      props.handleGetRecipeNutritionFacts();
    }
    // set component type to none if no fruit or veg values
    if (
      !hasWholeValue(values[Fields.Fruit]) &&
      totalVeg === 0 &&
      parseInt(values[Fields.ComponentType], 10) === COMPONENT_TYPE.Juice
    ) {
      dispatch(
        change(EDIT_RECIPE_FORM_NAME, Fields.ComponentType, COMPONENT_TYPE.None)
      );
    }

    if (!hasWholeValue(values[Fields.Milk])) {
      dispatch(
        change(EDIT_RECIPE_FORM_NAME, Fields.Milk_LowFatFlavored, false)
      );
      dispatch(
        change(EDIT_RECIPE_FORM_NAME, Fields.Milk_LowFatUnflavored, false)
      );
      dispatch(change(EDIT_RECIPE_FORM_NAME, Fields.Milk_ReducedUnflavored, false));
      dispatch(change(EDIT_RECIPE_FORM_NAME, Fields.Milk_ReducedFlavored, false));
      dispatch(change(EDIT_RECIPE_FORM_NAME, Fields.Milk_WholeUnflavored, false));
      dispatch(change(EDIT_RECIPE_FORM_NAME, Fields.Milk_WholeFlavored, false));
      dispatch(change(EDIT_RECIPE_FORM_NAME, Fields.Milk_SkimFlavored, false));
      dispatch(
        change(EDIT_RECIPE_FORM_NAME, Fields.Milk_SkimUnflavored, false)
      );
    }
  }
};

const onSubmitFail = (errors) => {
  const result = scrollOnSubmitFail()(errors);
  if (errors[Fields.Ingredients]) {
    const el = document.querySelector(`[name="${result}"]`);
    if (!el) {
      createToast(
        toastType.error,
        'Form submission failed',
        'Please check your ingredients for required fields marked in red.',
        true
      );
    }
  }
};

const EditRecipeForm = reduxForm({
  form: EDIT_RECIPE_FORM_NAME,
  asyncValidate,
  asyncBlurFields: ['AllAllergens[].Description'],
  validate,
  onChange,
  onSubmitFail,
  destroyOnUnmount: false,
})(withRecipesSubscription(EditRecipeFormContainer));

export { EditRecipeForm };



// WEBPACK FOOTER //
// ./src/pages/managerecipe/subpages/editrecipe/EditRecipeForm.js